/**
 * @generated SignedSource<<984b4b36f0525b6082e7c5dbd650e156>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type composerQueriesImagesMacroQueriesCategoriesFragmentQuery$variables = {
  isLibrary?: boolean | null;
  onlybackground?: boolean | null;
};
export type composerQueriesImagesMacroQueriesCategoriesFragmentQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"composerQueriesImagesMacroQueriesCategories_fragment">;
};
export type composerQueriesImagesMacroQueriesCategoriesFragmentQuery = {
  response: composerQueriesImagesMacroQueriesCategoriesFragmentQuery$data;
  variables: composerQueriesImagesMacroQueriesCategoriesFragmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isLibrary"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "onlybackground"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasImages",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSystemwide",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfProducts",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referenceKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "composerQueriesImagesMacroQueriesCategoriesFragmentQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "composerQueriesImagesMacroQueriesCategories_fragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "composerQueriesImagesMacroQueriesCategoriesFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "isLibrary",
            "variableName": "isLibrary"
          },
          {
            "kind": "Variable",
            "name": "onlybackground",
            "variableName": "onlybackground"
          }
        ],
        "concreteType": "ImageMacroCategory",
        "kind": "LinkedField",
        "name": "imageMacroCategories",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "onlyForBackgrounds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "macroCategoryPosition",
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageCategory",
            "kind": "LinkedField",
            "name": "categories",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "categoryPosition",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b7e9e6c310b2b949b33fd02c70b272e6",
    "id": null,
    "metadata": {},
    "name": "composerQueriesImagesMacroQueriesCategoriesFragmentQuery",
    "operationKind": "query",
    "text": "query composerQueriesImagesMacroQueriesCategoriesFragmentQuery(\n  $isLibrary: Boolean\n  $onlybackground: Boolean\n) {\n  ...composerQueriesImagesMacroQueriesCategories_fragment\n}\n\nfragment composerQueriesImagesMacroQueriesCategories_fragment on Query {\n  imageMacroCategories(onlybackground: $onlybackground, isLibrary: $isLibrary) {\n    id\n    name\n    hasImages\n    isSystemwide\n    numberOfProducts\n    onlyForBackgrounds\n    macroCategoryPosition\n    referenceKey\n    categories {\n      id\n      name\n      hasImages\n      isSystemwide\n      numberOfProducts\n      categoryPosition\n      referenceKey\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ffcb9081aa963c7df2ece2f406643d10";

export default node;
